<template>
    <div>
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
                 class="demo-ruleForm login-container" @submit.native.prevent>
            <h3 class="title">Login</h3>
            <el-form-item prop="account">
                <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="UserName"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
                <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"
                          placeholder="Password"></el-input>
            </el-form-item>
            <el-form-item align="right">
                <a type="primary" style="margin-bottom: 15px;cursor: pointer;color: #409eff;" @click="$router.push('forgetPassword')">Forgot Password</a>
            </el-form-item>
            <el-form-item style="width:100%;">
                <el-button type="primary" style="width:100%;" native-type="submit" @click.native.prevent="handleSubmit2" :loading="logining">
                    Login
                </el-button>
                <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
            </el-form-item>
        </el-form>
        <el-dialog title="Choose Company" width="80%" :visible.sync="selectCompanyVisible">
            <el-form :model="obj" label-width="220px" ref="obj" :rules="rule">
                <el-form-item label="Company" prop="currentCompany">
                    <el-select v-model="obj.currentCompany" auto-complete="off">
                        <el-option v-for="(doctor,index) in doctors" :key="index" :label="doctor.userName" :value="doctor.userNo"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="selectCompanyVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleSelectCompany">Choose</el-button>
            </div>
        </el-dialog>
    </div>

</template>


<script>
    import {login} from '../api/securityService';
    import {getNurseDoctor} from "../api/memberService";
    import ElOption from "element-ui/packages/select/src/option";

    export default {
        components: {ElOption},
        data() {
            return {
                obj:{
                    currentCompany:""
                },
                doctors:[],
                selectCompanyVisible: false,
                logining: false,
                ruleForm2: {
                    account: '',
                    checkPass: ''
                },
                rule:{
                    currentCompany: [
                        {required: true, message: 'You must select a company before login.', trigger: 'blur'},
                        //{ validator: validaePass }
                    ]
                },
                rules2: {
                    account: [
                        {required: true, message: 'Please enter username', trigger: 'blur'},
                        //{ validator: validaePass }
                    ],
                    checkPass: [
                        {required: true, message: 'Please enter password', trigger: 'blur'},
                        //{ validator: validaePass2 }
                    ]
                },
                checked: true
            };
        },
        methods: {
            handleSelectCompany(){
                this.$refs.obj.validate((valid)=>{
                    if(valid){
                        window.sessionStorage.setItem("currentCompany",this.obj.currentCompany);
                        this.$router.push({path: '/home'});
                    }
                })
            },
            handleReset2() {
                this.$refs.ruleForm2.resetFields();
            },
            getDoctors() {
                getNurseDoctor().then((res) => {
                    if (res.status === 200) {
                        this.doctors = res.result;
                        this.selectCompanyVisible = true;
                        if (this.doctors.length == 1) {
                            this.obj.currentCompany = this.doctors[0].userNo;
                            if (this.obj.currentCompany) {
                                window.sessionStorage.setItem("currentCompany",this.obj.currentCompany);
                                this.$router.push({path: '/home'});
                            }
                        }
                    }
                })
            },
            handleSubmit2(ev) {
                let _this = this;
                this.$refs.ruleForm2.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        let loginParams = {userName: this.ruleForm2.account, password: this.ruleForm2.checkPass};
                        login(loginParams).then(data => {
                            this.logining = false;
                            if (data.status === 200) {
                                sessionStorage.setItem('user', JSON.stringify(data.result.user));
                                sessionStorage.setItem("authorization", data.result.user.token);
                                if (data.result.user.roleId == 1 || data.result.user.roleId == 0) {
                                    this.$router.push({path: '/home'});
                                } else {
                                    this.getDoctors();
                                }

                            } else {
                                this.$message.error(data.message);
                            }
                        }).catch(data => {
                            console.log(data)
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }

</script>

<style lang="scss" scoped>
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// Login.vue?c46ce650